
import { React, useState, useRef } from "react";
import ContactPopup from "../ContactPopup";
// import "./ServicePages.css";
import "../PrivateLimitedCompany.css";
const RcmcRegistration = () => {
  const [openPopup, setOpenPopup] = useState(false);

  const contactRef = useRef(null);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  }


  return (
    <div className="service-page">

      {/* HERO */}
      <div className="hero">

        <h1>RCMC Registration Services</h1>

        <p className="subtitle">
          Get Recognized as an Authorized Exporter
        </p>

        <p className="desc">
          Unlock Export Benefits & Government Incentives
        </p>

        <p className="desc">
          We assist exporters in obtaining RCMC (Registration Cum Membership Certificate) quickly and correctly so you can access export benefits, incentives, and industry support without delays.
        </p>

        <div className="badges">
          <span>✔ Fast Online Assistance</span>
          <span>✔ Expert Export Guidance</span>
          <span>✔ End-to-End Support</span>
          <span>✔ Hassle-Free Process</span>
        </div>

        <div className="hero-action">
          <button className="hero-btn" onClick={scrollToContact}>
            Get Started Today
          </button>
        </div>

      </div>

      {/* WHAT IS RCMC */}
      <div className="section">
        <h2>What is RCMC?</h2>
        <p>
          Federation of Indian Export Organisations (FIEO) and other Export Promotion Councils issue the RCMC (Registration Cum Membership Certificate) to exporters as proof of registration with the relevant council.
        </p>
        <p>
          It is required to avail benefits under various export promotion schemes in India.
        </p>
      </div>

      {/* BENEFITS */}
      <div className="section">
        <h2>Benefits of RCMC Registration</h2>
        <ul>
          <li>Access to export incentives and schemes</li>
          <li>Eligibility for DGFT benefits</li>
          <li>Recognition as a registered exporter</li>
          <li>Participation in trade fairs & exhibitions</li>
          <li>Industry-specific support & guidance</li>
          <li>Easier compliance with export regulations</li>
        </ul>
      </div>

      {/* WHO NEEDS */}
      <div className="section">
        <h2>Who Needs RCMC?</h2>
        <ul>
          <li>Exporters of goods and services</li>
          <li>Manufacturing companies</li>
          <li>Trading export businesses</li>
          <li>MSME exporters</li>
          <li>Agricultural & textile exporters</li>
          <li>Service exporters (IT, consulting, etc.)</li>
        </ul>
      </div>

      {/* EXPORT COUNCILS */}
      <div className="section">
        <h2>Types of Export Councils</h2>
        <ul>
          <li>Engineering Export Promotion Council (EEPC)</li>
          <li>Apparel Export Promotion Council (AEPC)</li>
          <li>Chemical & Allied Products Council</li>
          <li>APEDA (for agricultural exports)</li>
          <li>Services Export Promotion Council</li>
        </ul>
      </div>

      {/* SERVICES */}
      <div className="section">
        <h2>Our RCMC Services Include</h2>
        <ul>
          <li>Export Council Selection Guidance</li>
          <li>Application Preparation</li>
          <li>Document Filing Support</li>
          <li>Membership Registration</li>
          <li>Compliance Assistance</li>
          <li>Renewal Support</li>
        </ul>
      </div>

      {/* DOCUMENTS */}
      <div className="section">
        <h2>Documents Required</h2>
        <ul>
          <li>Import Export Code (IEC)</li>
          <li>GST Certificate</li>
          <li>PAN Card</li>
          <li>Business Address Proof</li>
          <li>Export Details (if applicable)</li>
          <li>Company Registration Documents</li>
        </ul>
      </div>

      {/* PROCESS */}
      <div className="section">
        <h2>RCMC Registration Process</h2>
        <ol>
          <li>Consultation – Identify correct export council</li>
          <li>Document Collection – Gather required details</li>
          <li>Application Filing – Submit to concerned council</li>
          <li>Verification – Council review</li>
          <li>Certificate Issued – Receive RCMC membership</li>
        </ol>
      </div>

      {/* WHY CHOOSE US */}
      <div className="section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>Export Compliance Experts</li>
          <li>Fast Approval Assistance</li>
          <li>Accurate Documentation</li>
          <li>Affordable Pricing</li>
          <li>Complete End-to-End Support</li>
        </ul>
      </div>

      {/* FAQ */}
      <div className="section">
        <h2>FAQs</h2>
        <p><b>Is RCMC mandatory for export?</b> It is required to avail most export incentives and schemes.</p>
        <p><b>How long does RCMC take?</b> Usually 3–7 working days depending on council.</p>
        <p><b>Is IEC required for RCMC?</b> Yes, IEC is mandatory.</p>
        <p><b>Do I need separate RCMC for different products?</b> Yes, based on product category and export council.</p>
      </div>

      {/* CTA */}
      <div className="cta" ref={contactRef}>
        <h2>Get Your RCMC Certificate Today</h2>
        <p>Unlock export benefits and grow your global business.</p>
        <div className="cta-buttons">
          <button onClick={() => setOpenPopup(true)}>Contact Us Now</button>
          <ContactPopup
            isOpen={openPopup}
            onClose={() => setOpenPopup(false)}
          />

          <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
        </div>
      </div>

    </div>
  );
};

export default RcmcRegistration;